import { addIsNewFeed } from "../helpers/helpers";

export function setFeedsData(state, data) {
  return {
    ...state,
    feeds: {
      ...state.feeds,
      data: data.map(addIsNewFeed)
    }
  }
}

export function setFeedsStatus(state, status) {
  return {
    ...state,
    feeds: {
      ...state.feeds,
      status: status
    }
  }
}

export function setCategory(state, category) {
  return { 
    ...state, 
    selectedCategory: category
 }
}

export function setFeedCategories(state, categories) {
  return {
    ...state,
    feedCategories: categories
  }
}